import { Alert, Box, Button } from '@mui/material'
import { Component, type ReactNode } from 'react'
import { captureError } from '../lib/sentry'

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch(err: unknown) { captureError(err) }
  render() {
    if (!this.state.failed) return this.props.children
    return (
      <Box sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
        <Alert severity="error" action={<Button color="inherit" onClick={() => location.reload()}>Reload</Button>}>Something went wrong.</Alert>
      </Box>
    )
  }
}
